import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import { Check, ExpandMore } from "@material-ui/icons";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import React, { useState, useEffect } from "react";

const CATEGORY_LABELS = {
  mc: "Marketing Charges",
  mlc: "Marketing Lite Charges",
  sc: "Service Charges",
  uc: "Utility Charges",
  ac: "Authentication Charges",
};

function BulkUpdate(props) {
  const { classes, applyBulkUpdate, activeTab = "mc" } = props;
  const [expanded, setExpanded] = useState(false);
  const [sign, setSign] = useState("%");
  const [value, setValue] = useState("");
  const [applied, setApplied] = useState(false);

  // Reset when activeTab changes
  useEffect(() => {
    setValue("");
    setApplied(false);
  }, [activeTab]);

  const SignToggle = () => {
    return (
      <ToggleButtonGroup
        value={sign}
        exclusive
        onChange={(e, newValue) => {
          if (newValue) {
            setSign(newValue);
            setApplied(false);
          }
          e.stopPropagation();
        }}
        aria-label="Sign toggle"
        style={{ padding: 0 }}
      >
        <ToggleButton
          value="%"
          aria-label="percentage"
          size="small"
          style={{
            padding: "4px 12px",
            background: sign === "%" ? "rgb(70 20 134)" : "#A9A9A9",
            borderColor: sign === "%" ? "rgb(70 20 134)" : "#A9A9A9",
            color: "white",
            fontWeight: 600,
          }}
        >
          Percentage
        </ToggleButton>
        <ToggleButton
          value="+"
          aria-label="custom value"
          size="small"
          style={{
            padding: "4px 12px",
            background: sign === "+" ? "rgb(70 20 134)" : "#A9A9A9",
            borderColor: sign === "+" ? "rgb(70 20 134)" : "#A9A9A9",
            color: "white",
            fontWeight: 600,
          }}
        >
          Custom Value
        </ToggleButton>
      </ToggleButtonGroup>
    );
  };

  const categoryLabel = CATEGORY_LABELS[activeTab] || "Marketing";

  return (
    <Accordion
      elevation={0}
      style={{ background: "transparent" }}
      className={`${classes.cells} ${classes.accordian}`}
      onChange={(e, isExpanded) => {
        setExpanded(isExpanded);
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className={classes.accordianSummary}
      >
        <Grid
          container
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
          }}
        >
          <Grid item xs={12} md={6} className={classes.cellText}>
            Bulk update {categoryLabel} margin
          </Grid>
          {expanded && (
            <Grid
              item
              xs={12}
              md={6}
              style={{ justifyContent: "flex-end", display: "flex" }}
            >
              <SignToggle />
            </Grid>
          )}
        </Grid>
      </AccordionSummary>
      <AccordionDetails
        style={{
          display: "flex",
          alignItems: "center",
          padding: 0,
          paddingTop: 16,
        }}
      >
        <Grid container>
          <Grid item xs={12} md={6}>
            <Typography variant="h5">{categoryLabel} Margin</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ justifyContent: "flex-end", display: "flex" }}
          >
            <TextField
              id="margin"
              placeholder="Specify margin here"
              name="margin"
              value={value}
              type="Number"
              onChange={(e) => {
                setValue(e.target.value);
                setApplied(false);
              }}
              className={classes.phoneTextFieldRoot}
              InputProps={{
                endAdornment: value && (
                  <InputAdornment position="start">
                    <Typography>({sign})</Typography>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              onClick={() => {
                applyBulkUpdate(activeTab, sign, Number(value));
                setApplied(true);
              }}
              color="primary"
              variant="contained"
              disabled={!value}
              startIcon={applied && <Check style={{ color: "white" }} />}
              style={{
                marginLeft: 8,
                padding: applied ? "8px 20px" : "8px 38px",
                marginTop: "4px",
                marginBottom: "20px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                background: applied ? "#50C878" : undefined,
                color: applied ? "#fff" : undefined,
              }}
            >
              {applied ? "Applied" : "Apply"}
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

const styles = (theme) => ({
  phoneTextFieldRoot: {
    width: "160px",
    padding: "4px 0px",
    marginTop: "4px",
    marginBottom: "20px",
    "& input": { width: "calc(100% - 8px)", marginLeft: "8px" },
    background: "white",
    border: "2px solid grey",
  },
  cellText: {
    fontSize: 16,
    fontWeight: 500,
  },
  accordianSummary: {
    paddingLeft: "0px",
    paddingRight: 0,
    paddingTop: 0,
    "&.Mui-expanded": {
      minHeight: "0px",
    },
  },
  accordian: {
    "&:before": {
      display: "none",
      paddingRight: 0,
    },
    "&.Mui-expanded": {
      minHeight: "0px",
      marginTop: "0px",
    },
  },
});

export default withStyles(styles)(BulkUpdate);
